import { render, staticRenderFns } from "./AddToGroupView.vue?vue&type=template&id=2798ebe4&"
import script from "./AddToGroupView.vue?vue&type=script&lang=js&"
export * from "./AddToGroupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports